import { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiAvatar from "components/SuiAvatar";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiBadge from "components/SuiBadge";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import ManageMoodboardModal2 from "pages/de/collection/detail/components/ManageMoodboardModal2";
import ImportMoodboardModal from "pages/de/collection/detail/components/ImportMoodboardModal";
import CollectionBackgroundEditModal from "pages/de/collection/detail/components/CollectionBackgroundEditModal";
import AddMoodboardModal from "pages/de/collection/components/AddMoodboardModal";

import api from "services/api";
import toast from "react-hot-toast";

const CollectionDetailHeader = ({ collection, handleRefresh, canWrite, sharedView }) => {
  const [imgsViewerVisible, setImgsViewerVisible] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [editBackgroundVisible, setEditBackgroundVisible] = useState(false);
  const [manageMoodboardVisible, setManageMoodboardVisible] = useState(false);
  const [importMoodboardVisible, setImportMoodboardVisible] = useState(false);
  const [createMoodboardVisible, setCreateMoodboardVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({});

  const navigate = useNavigate();

  const collectionMoodboards = collection?.moodboard || [];
  const primaryImage = collectionMoodboards?.[0]?.img || {};
  const backgroundImageUrl = primaryImage?.url || "";
  const moodboard = collection?.moodboard?.[0] || {};

  const handleCloseMoodboardMenu = () => {
    setAnchorEl(null);
    setMousePosition({});
  };
  const MoodboardMenu = () => (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleCloseMoodboardMenu}
      anchorReference={mousePosition?.clientX ? "anchorPosition" : "anchor"}
      anchorPosition={{ top: mousePosition?.clientY + 4, left: mousePosition?.clientX + 4 }}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      {moodboard?.id || sharedView ? null : (
        <MenuItem
          onClick={() => {
            setCreateMoodboardVisible(true);
            handleCloseMoodboardMenu();
          }}
        >
          Create Moodboard
        </MenuItem>
      )}
      {moodboard?.id || sharedView ? null : (
        <MenuItem
          onClick={() => {
            setImportMoodboardVisible(true);
            handleCloseMoodboardMenu();
          }}
        >
          Import Moodboard
        </MenuItem>
      )}
      {moodboard?.id ? (
        <MenuItem onClick={handleEditMoodboard}>{canWrite ? "Edit Moodboard" : "Preview"}</MenuItem>
      ) : null}
      {moodboard?.id && !sharedView ? (
        <MenuItem onClick={handleRemoveMoodboard}>Remove Moodboard</MenuItem>
      ) : null}
    </Menu>
  );

  const handleEditMoodboard = async () => {
    handleCloseMoodboardMenu();

    if (!moodboard.id) {
      return toast.error(`Ccan't find the moodboard!`);
    }
    sharedView
      ? navigate(`/shared-with-me/moodboards?id=${moodboard.id}`)
      : navigate(`/workspace/moodboard?id=${moodboard.id}`);
  };

  const handleRemoveMoodboard = async () => {
    handleCloseMoodboardMenu();

    if (!moodboard.id) {
      return toast.error(`Ccan't find the moodboard!`);
    }

    const { data } = await api.moodboard.updateCollectionRelation(moodboard.id, {
      collection_id: null,
    });

    toast.success(`Remove moodboard successfully!`);

    handleRefresh();
  };

  const handleClickMoodboard = (e) => {
    e.stopPropagation();
    if (anchorEl != null) {
      return;
    }

    if (backgroundImageUrl) {
      //setManageMoodboardVisible(true);
      sharedView
        ? navigate(`/shared-with-me/moodboards?id=${moodboard.id}`)
        : navigate(`/workspace/moodboard?id=${moodboard.id}`);
    } else {
      if (sharedView) {
        return;
      } else {
        //using cursor location instead of element position
        setMousePosition({ clientX: e.clientX, clientY: e.clientY });
        setAnchorEl(e.target);
      }
    }
  };

  return (
    <SuiBox position="relative">
      <div>
        <SuiBox
          display="flex"
          alignItems="center"
          position="relative"
          minHeight={"20.75rem"}
          width="100%"
          borderRadius="xl"
          sx={{
            backgroundImage: backgroundImageUrl
              ? ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
                  `url(${backgroundImageUrl})`
              : ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
                  `${linearGradient("#ffffff", rgba(gradients.secondary.state, 0.4), 0)}`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            //backgroundPosition: "50%",
            backgroundPosition: "top",
            overflow: "hidden",
            cursor: "pointer",
          }}
          onClick={handleClickMoodboard}
        >
          {backgroundImageUrl || !sharedView ? (
            <SuiBadge
              variant="gradient"
              color={"info"}
              sx={{ position: "absolute", top: 8, right: 12, cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(e.currentTarget);
              }}
              container
              badgeContent={"Manage Moodboard"}
            />
          ) : null}

          <MoodboardMenu />

          {backgroundImageUrl || sharedView ? null : (
            <SuiTypography
              variant="h6"
              color="secondary"
              fontWeight="regular"
              display="flex"
              alignItems="flex-start"
              justifyContent="center"
              width="100%"
              sx={{ mb: 10 }}
            >
              {moodboard?.id
                ? "Click to edit moodboard!"
                : "Click to create or import a moodboard!"}
            </SuiTypography>
          )}
        </SuiBox>
      </div>

      {manageMoodboardVisible ? (
        <ManageMoodboardModal2
          visible={manageMoodboardVisible}
          handleClose={() => setManageMoodboardVisible(false)}
          handleOk={null}
          collection={collection}
          handleRefresh={() => {
            handleRefresh();
          }}
          canWrite={canWrite}
          sharedView={sharedView}
        />
      ) : null}
      {importMoodboardVisible ? (
        <ImportMoodboardModal
          visible={importMoodboardVisible}
          handleClose={() => setImportMoodboardVisible(false)}
          collection={collection}
          handleRefresh={handleRefresh}
          selectedMoodboards={[]}
        />
      ) : null}
      {createMoodboardVisible && collection?.id ? (
        <AddMoodboardModal
          handleClose={() => {
            setCreateMoodboardVisible(false);
          }}
          visible={createMoodboardVisible}
          collection={collection}
          handleRefresh={handleRefresh}
        />
      ) : null}
    </SuiBox>
  );
};

export default CollectionDetailHeader;
